/***
 * 客服中心-客户管理
 *  */
// 定制逻辑处理
export default {
  // 收货客户，新增地址，自定义维护省市区
  consignee_use_custom_district: ['97276'], // 202506271345172879942
  // 新增和编辑客户资料后，不刷新页面
  no_refresh_list_after_customer: ['96967', '95822', '82337', '90100'], // 202507231427283673972
  // 新增发货人界面，增加是否含税字段
  add_shipper_show_taxtype: ['95110'], // 202508042012120406860
  // 发货客户资料维护界面，增加 单价重量 单件体积 区域
  show_pweight_pvolumn: ['98206'] // 202511052123589105258
}
